// extracted by mini-css-extract-plugin
export var text = "_12-0";